module.exports = __webpack_public_path__ + "img/sidebar.55630c55.svg";